import { Component, ElementRef, OnInit } from '@angular/core';
import { ActiveRentalService, NavigationService } from 'app-components';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import { PageBase, DiscountModel } from 't4core';

@Component({
  selector: 'app-return-complete',
  templateUrl: './return-complete.component.html',
  standalone: false
})
export class ReturnCompleteComponent extends PageBase implements OnInit {
  public theme: string;
  public primaryContent: string;
  public loading: boolean = false;
  public hasActiveCampaign: boolean = false;
  public discount: DiscountModel;
  constructor(el: ElementRef, private aviationService: NavigationService, public appSettings: AppSettingsService, private appIntegrationService: AppIntegrationService, private rentalService: ActiveRentalService) {
    super(el);
  }

  async ngOnInit() {
    var rental = await this.rentalService.getBooking();

    this.Insights.logEvent("Return complete", { rentalId: rental?.Id + "" });
    this.loading = true;
    this.theme = this.appSettings.settings.theme || 'Default';
    this.discount = await this.Api.get<DiscountModel>("/Campaign/CheckActiveInviteFriendsCampaign", { triggerAction: 2, bookingId: this.aviationService.getParam('rentalId') });//trigger enum return is set as value 2.

    this.primaryContent = await this.Translate.translate('Intellitrailer.Rental.ReturnComplete.SuccessfulRentWithTheme', 'Your rental is complete – thank you for using {theme}!');
    this.primaryContent = this.primaryContent.replace("{theme}", this.theme);

    this.hasActiveCampaign = this.discount.IsInviteFriendsCampaign;
    this.loading = false;
    if (this.hasActiveCampaign) {
      setTimeout(() => {
        this.appIntegrationService.requestAppReview();
      }, 10000);
    }
    else {
      this.appIntegrationService.requestAppReview();
    }
    this.appIntegrationService.refreshRentals("Returned", rental.Id);
  }


  public confirm() {
    this.aviationService.executeCommand("TakeMeHome");
  }


}
